// extracted by mini-css-extract-plugin
export default {"base":"TitleMajor_base__48Dub"};